import styles from './BreadCrumb.module.scss';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { IBreadCrumb } from './BreadCrumb.types';

const BreadCrumb = ({ items }: IBreadCrumb) => {
  return (
    <div className={styles['ds-breadcrumb-container']}>
      {items.map((item, index) => {
        const { url, label } = item;
        const isLastItem = index === items.length - 1;

        return (
          <div key={index} className={styles['breadcrumb-item']}>
            {index > 0 && <p className={styles['separator']}>/</p>}
            <Link
              className={classNames(styles['breadcrumb-link'], { [styles['breadcrumb-link-active']]: isLastItem })}
              to={url}
            >
              {label}
            </Link>
          </div>
        );
      })}
    </div>
  );
};

export default BreadCrumb;
